import UserForm from './UserForm'

const Create = () => {
    return (
        <UserForm
            inPopup={false}
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'User created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create user',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating user...',
                },
            }}
        />
    )
}

export default Create
